<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="!saleTurnover?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
              <div class="text-gray-700 fs-4 fw-bold">{{ $t('statistics.sale_turnover') }}</div>
            </div>
            <div v-if="saleTurnover?.length" class="p-5">
              <h5 style="margin-bottom: 20px; text-align: start">{{ $t('statistics.sale_turnover') }} ({{ defaultCurrency?.symbol }})</h5>
              <canvas id="kt_chartjs_turnover" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import {  shallowRef,onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Loader from '@/components/Loader.vue';
import { watch } from 'vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    
})

const saleTurnover = ref([])
const chartTurnoverRef = shallowRef(null)

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})



function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date}).then((res) => {
          saleTurnover.value = res?.data?.sales_by_period || res?.response?.data;


        }), 
    ]).then(() => {
      chartTurnover()
    }) 
  }
    
}

function chartTurnover(){
  let monthlyData = [];
  let monthlyLabels = [];

  saleTurnover.value?.forEach(turnover => {
      if(turnover.value != 0){
        monthlyData.push(turnover.value)
        monthlyLabels.push(turnover.date)
      } 
  })

  if(monthlyData.length <= 0){
    saleTurnover.value = []
  }
  
  let ctx = document.getElementById('kt_chartjs_turnover');
 
  if (ctx) {
    if(Chart.getChart("kt_chartjs_turnover")) {
      Chart.getChart("kt_chartjs_turnover")?.destroy()
    }
    let context = ctx.getContext('2d');
    let data = {
      labels: monthlyLabels,
      datasets: [{
          label: 'Earnings',
          data: monthlyData,
          fill: true,
          borderColor: 'rgba(75, 192, 192, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          tension: 0.4,
      }]
    };

    let config = {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return `${i18n.global.t('statistics.amount')}: ${$formatLocalAmount(context.parsed.y)} ${defaultCurrency.value?.symbol}`;
                    }
                }
            }
          }
        }
    };

    if (!chartTurnoverRef.value) {
      chartTurnoverRef.value = new Chart(ctx, config);
    }else{
      chartTurnoverRef.value.destroy()
      chartTurnoverRef.value = new Chart(ctx, config);
    }
  } else {
    console.error('Canvas element not found');
  }
  
}

  
onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>